<template>
  <div>
    <!-- 下锅工作模式-->
<!--    <el-form-item :label="$t('lang.工作模式')" required>
      <div style="display: flex;">
        <div class="select-mask" @click="handleSelectDownWorkMode">
          <el-select
            :disabled="wordModeDisabled"
            v-model="stepItem.workMode2nd"
            :placeholder="$t('lang.请选择')"
            @change="handleChangeWorkMode2nd">
            <el-option
              v-for="m in modelList"
              :key="m.value"
              :label="m.name"
              :value="m.value" />
          </el-select>
        </div>

        <el-popover
          v-if="stepItem.workMode2nd"
          placement="top-start"
          width="200"
          trigger="hover"
          :content="$t(`lang.${TH_WORK_MODE[stepItem.workMode2nd]}`)">
          <i class="el-icon-question explain" slot="reference" />
        </el-popover>
      </div>
      <mode-list ref="modeDialog" />
    </el-form-item>-->

    <!--  空炸-下锅的配置    -->
    <div style="display: flex">
      <!-- 温度 -->
      <temperature
        v-model="stepItem.temperature2nd"
        :dev-mode="devMode2nd"
        :permissions="permissions"
        @change="handleParamChange" />

      <!-- 旋转方向 -->
      <rotate-direction
        value=""
        :dev-mode="devMode2nd"
        :permissions="permissions"
        :is-air="isAir"
        :rotate-direction="rotateDirection" />

      <!-- 旋转速度 -->
      <rotate-speed
        value=""
        :dev-mode="devMode2nd"
        :permissions="permissions"
        :is-air="isAir"
        :get-motor-gear-count="getMotorGearCountFn"
        :rotate-direction="stepItem.rotateDirection"
        @change="handleParamChange" />

      <!-- 喷水档位 -->
      <water-gear
        value=""
        :dev-mode="devMode2nd"
        :permissions="permissions"
        @change="handleParamChange" />

      <!-- 时间-分 -->
      <minute
        v-model="stepItem.minute2nd"
        :dev-mode="devMode2nd"
        :permissions="permissions"
        :minute-time="minuteTime"
        @change="handleParamChange" />

      <!-- 时间-秒 -->
      <second
        v-model="stepItem.second2nd"
        :dev-mode="devMode2nd"
        :permissions="permissions"
        @change="handleParamChange" />
    </div>
  </div>
</template>

<script>
import {TH_WORK_MODE} from "./utils";
// import ModeList from "./ModeList";
import potParamsMixin from "./mixins/potParamsMixin";
// 参数字段组件
import Temperature from "./params/Temperature";
import RotateDirection from "./params/RotateDirection";
import RotateSpeed from "./params/RotateSpeed";
import WaterGear from "./params/WaterGear";
import Minute from "./params/Minute";
import Second from "./params/Second";

export default {
  name: 'SecondPotParams',
  mixins: [potParamsMixin],
  components: {
    // ModeList,
    Temperature,
    RotateDirection,
    RotateSpeed,
    WaterGear,
    Minute,
    Second
  },
  props: {
    // 步骤数据对象（包含所有下锅相关字段）
    stepItem: {
      type: Object,
      required: true
    },
    // 工作模式列表（用于过滤）
    workModelList: {
      type: Array,
      default: () => []
    },
    // 食谱类型
    type: {
      type: String,
      required: true
    },
    // 锅体类型（用于多类型场景）
    stepPotType: {
      type: String,
      default: ''
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 旋转方向选项（这个需要从外部传入，因为可能来自不同的数据源）
    rotateDirection: {
      type: Array,
      default: () => []
    },
    // 工作模式配置
    devMode2nd: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      TH_WORK_MODE,
      // devMode2nd: null
    };
  },
  computed: {
    getMotorGearCountFn() {
      return this.getMotorGearCount(this.stepItem.rotateDirection);
    }
  },
  // created() {
  //   if (this.stepItem.workMode2nd) {
  //     this.devMode2nd = this.$store.state.devModes[this.stepItem.workMode2nd];
  //   }
  // },
  // watch: {
  //   'stepItem.workMode2nd': {
  //     handler(newVal) {
  //       if (newVal) {
  //         this.devMode2nd = this.$store.state.devModes[newVal];
  //       } else {
  //         this.devMode2nd = null;
  //       }
  //     },
  //     immediate: true
  //   }
  // },
  methods: {

    // 选择下锅工作模式
    handleSelectDownWorkMode() {
      this.$refs.modeDialog.showDialog(this.modelList, this.stepItem.workMode2nd, (res) => {
        this.$set(this.stepItem, 'workMode2nd', res.value);
        this.handleChangeWorkMode2nd(res.value);
      });
    },

    // 切换下锅工作模式
    handleChangeWorkMode2nd(mode) {
      // 重置下锅工作参数
      let devMode = this.$store.state.devModes[mode];
      if (!devMode) return;

      // this.devMode2nd = devMode;

      // 更新下锅参数（直接修改 stepItem，保持响应式）
      this.$set(this.stepItem, 'temperature2nd', devMode.defaultTemp);
      this.$set(this.stepItem, 'minute2nd', parseInt((devMode.defaultTime / 60)));
      this.$set(this.stepItem, 'second2nd', parseInt((devMode.defaultTime % 60)));
      // 组件内部已处理所有逻辑，不需要通知外部
    },

    // 参数校验（下锅专用，使用下锅的时间字段）
    handleParamChange() {
      let devMode = this.devMode2nd;

      // 如果 devMode 不存在，直接返回
      if (!devMode) return;

      // 使用下锅的时间字段
      let minute = this.stepItem.minute2nd || 0;
      let second = this.stepItem.second2nd || 0;
      let time = ((minute * 60) + second);

      if (time > devMode.maxTime) {
        this.$set(this.stepItem, 'minute2nd', parseInt(devMode.maxTime / 60));
        this.$set(this.stepItem, 'second2nd', parseInt(devMode.maxTime % 60));
      }
    },
  }
};
</script>

<style scoped>
.select-mask {
  width: 217px;
  height: 40px;
  position: relative;
}

.select-mask::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 99;
  cursor: pointer;
}

.explain {
  font-size: 20px;
  margin-left: 16px;
}
</style>

